import { render } from "./AlgaeWashup.vue?vue&type=template&id=2aa4cfae"
import script from "./AlgaeWashup.vue?vue&type=script&lang=js"
export * from "./AlgaeWashup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/coastal-watchers-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__